import React from 'react';
import { ErrorMessage, ErrorMessageProps } from 'formik';

type ErrorFieldsProps = ErrorMessageProps;

export const ErrorField = (props: ErrorFieldsProps) => {
  return <ErrorMessage className="text-porchetta-red text-xs mt-1" component="p" {...props} />;
};
